import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromActions from '../actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ParametersService } from '../../../core/services/parameters.service';

@Injectable()
export class CountriesEffects {

  constructor(
    private actions$: Actions,
    private parametersService: ParametersService
  ) { }

  loadSidebar$ = createEffect(
    () => this.actions$.pipe(
      ofType(fromActions.loadCountries),
      mergeMap(
        () => this.parametersService.countries()
          .pipe(
            map( entities => fromActions.loadCountriesSuccess({ entities })),
            catchError(() => EMPTY)
          )
      )
    )
  );

}
